<template>
  <div class="recommend-course">
    <p class="title">推荐课程</p>
    <OrgCourseCard
      :courseInfo="courseInfo"
      :showOrgInfo="false"
      :needAdaptStyle="false"
    />
  </div>
</template>

<script>
import OrgCourseCard from "@saas/pages/src/home/components/CourseCard";
export default {
  components: { OrgCourseCard },
  props: {
    courseInfo: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped>
.recommend-course {
  margin-top: 16px;
  height: 376px;
  background: #ffffff;
  border-radius: 18px;
  padding-top: 14px;
  .title {
    font-weight: 500;
    font-size: 18px;
    color: #0d1400;
    line-height: 25px;
    padding: 0 18px;
  }
  ::v-deep .course-card {
    margin: 0 auto;
    width: 380px;
    transition: none;
    padding: 16px 12px 16px;
    height: auto;
    &:hover {
      transform: none;
      box-shadow: none;
    }

    .cover {
      transition: none;
      transform: none;
    }
    .cover-wrap {
      width: 356px;
      height: 196px;
    }
    .course-info {
      height: 125px;
      flex: auto;
    }
  }
}
</style>
